module.exports = __webpack_public_path__ + "static/img/v70TwoBg-p.2593e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70TwoBg-p.png
// module id = yydi
// module chunks = 1